import React, { Component } from "react";
import ProgressiveBackgroundImage from "../../progressiveImage";
import { Container, Grid } from "semantic-ui-react";

class BookingHeader extends Component {
  render() {
    // console.log(this.props);
    const { chat, calendar, clock, noContracts, visa } = this.props.icons;
    return (
      <ProgressiveBackgroundImage
        preview={this.props.images.base64}
        src={this.props.images.originalImg}
        darken={"0.5"}
      >
        <div
          style={{
            minHeight: "80vh",
            color: "white",
            paddingTop: "20vh",
            paddingBottom: "5vh"
          }}
        >
          <Container text>
            <h2>YOU'RE 60 SECONDS AWAY FROM AWESOME CLEANING</h2>
            <Grid
              doubling
              padded
              stackable
              centered
              columns={5}
              style={{ paddingTop: "30px" }}
            >
              <Grid.Column style={{ textAlign: "center" }}>
                <img src={calendar.original.src} alt="calendar" />
                <br />
                <span>Choose your date and time 7 days a week</span>
              </Grid.Column>
              <Grid.Column style={{ textAlign: "center" }}>
                <img src={clock.original.src} alt="clock" />
                <br />
                <span>Book in one minute</span>
              </Grid.Column>
              <Grid.Column style={{ textAlign: "center" }}>
                <img src={visa.original.src} alt="visa" />
                <br />
                <span>Pay securely online</span>
              </Grid.Column>
              <Grid.Column style={{ textAlign: "center" }}>
                <img src={noContracts.original.src} alt="no means no" />
                <br />
                <span>No contracts</span>
                <br />
                <span>Cancel anytime</span>
              </Grid.Column>
              <Grid.Column style={{ textAlign: "center" }}>
                <img src={chat.original.src} alt="chat" />
                <br />
                <span>No upsells or hidden pricing</span>
              </Grid.Column>
            </Grid>
          </Container>
        </div>
      </ProgressiveBackgroundImage>
    );
  }
}

export default BookingHeader;



// WEBPACK FOOTER //
// ./src/components/Booking/Header/index.jsx